import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AuthGuardService } from './services/common/auth-guard.service';
import { ListingComponent } from './components/common/listing/listing.component';
import { StudentHomeComponent } from './components/student-home/student-home.component';
import { HomeViewOnlyComponent } from './components/home-viewonly/home-viewonly.component';

const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'listing' },
	{
		path: 'listing',
		component: ListingComponent,
		canActivate: [ AuthGuardService ]
	},
	{ path: 'student', component: StudentHomeComponent, canActivate: [ AuthGuardService ] },
	{ path: 'checklist', component: HomeViewOnlyComponent, canActivate: [ AuthGuardService ] },
	{ path: '**', component: HomeComponent, canActivate: [ AuthGuardService ] }
];

@NgModule({
	imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
